import { selectGroup } from "./SelectGroup.css";

interface SelectGroupProps {
  children: React.ReactNode;
}

export function SelectGroup({ children }: SelectGroupProps) {
  return <div className={selectGroup}>{children}</div>;
}
